var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('client-only',[_c('confirmation-page',{attrs:{"info":_vm.pageInfo},on:{"submit":function($event){return _vm.submit()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }